import React from 'react'
import { MenuItem, Select } from '@mui/material'
import { useGetTimezones } from '../../features/settings/hooks'

export const TimeZoneField = ({ field, fieldValue, onDataEntry }: any) => {
  const { data: timezones, isFetching: isFetchingZones } = useGetTimezones()
  return (
    <Select
      id={field.name}
      name={field.name}
      value={fieldValue}
      placeholder={field.placeholder}
      variant='filled'
      onChange={onDataEntry}>
      {timezones &&
        timezones.map((timeZone: any, index: any) => {
          return timeZone.show ? (
            <MenuItem key={timeZone.tz} value={timeZone.tz}>
              {timeZone.tz}
            </MenuItem>
          ) : null
        })}
    </Select>
  )
}
